import React from 'react';
import { REDIAL_CHOICES } from './powerDialConstants.js';

export default function RedialSelector({ redialAttempts, setRedialAttempts }) {
  return (
    <div className="mb-4">
      <label htmlFor="pd-redial" className="block text-xs uppercase tracking-wider text-white/60 font-semibold mb-2">
        Redial Attempts
      </label>
      <select
        id="pd-redial"
        value={redialAttempts}
        onChange={(e) => setRedialAttempts(Number(e.target.value))}
        className="w-full bg-white/5 border border-white/10 rounded-lg px-3 py-2.5 text-sm text-white focus:border-civix-purple outline-none"
      >
        {REDIAL_CHOICES.map((c) => (
          <option key={c.value} value={c.value} className="bg-[#0F0E17]">{c.full}</option>
        ))}
      </select>
    </div>
  );
}
